import React, { createContext, useContext } from "react";
 
const AuthorizationContext = createContext([]);
 
export const AuthorizationProvider = ({ AccessAreas, children }) => {
    return (
        <AuthorizationContext.Provider value={AccessAreas}>
            {children}
        </AuthorizationContext.Provider>
    );
};
 
export const useAuthorization = () => useContext(AuthorizationContext);